import React, { FC, MouseEvent } from 'react'
import { StyledUserSettingsButton } from './UserSettingsButton.styled'

export interface UserSettingsButtonProps {
    btnType: 'primary' | 'muted' | 'danger'
    onClick: (e: MouseEvent<HTMLElement>) => void
    disabled?: boolean
}

export const UserSettingsButton: FC<UserSettingsButtonProps> = ({
    btnType,
    onClick,
    children,
    disabled,
}) => (
    <StyledUserSettingsButton
        onClick={onClick}
        btnType={btnType}
        disabled={disabled}
    >
        {children}
    </StyledUserSettingsButton>
)
